export function formatNumber(value) {
  const number = Number(value);
  const safeNumber = isNaN(number) ? 0 : number;
  return safeNumber.toLocaleString("th-TH", { minimumFractionDigits: 2 });
}
